import { TOOL_MESSAGES } from "@/components/Chat/messages/components/ToolSkeletonLoader";
import { getToolCategory } from "@/components/Chat/messages/utils/toolHelpers";
import { useThreadStore } from "@/store";
import { useImageModelStore } from "@/store/imageModelStore";

/**
 * Hook to reactively track active tool skeleton state
 * Subscribes to currentToolCallName from threadStore via Zustand selector
 *
 * @returns {Object} - { toolName, toolCategory, isActive, displayMessage }
 */
export function useActiveToolSkeleton() {
  // Reactively subscribe to currentToolCallName from threadStore
  const currentToolCallName = useThreadStore(
    (state) => state.currentToolCallName
  );

  // Get image model parameters for dynamic message
  const getCurrentModelParameters = useImageModelStore(
    (state) => state.getCurrentModelParameters
  );

  // Derive tool category from the raw tool name
  const toolCategory = currentToolCallName
    ? getToolCategory(currentToolCallName)
    : null;

  // Determine if a tool is actively being processed
  const isActive = !!currentToolCallName;

  // Get the display message for the current tool
  // For image_generation, check if generating multiple images
  let displayMessage = null;
  if (toolCategory) {
    if (toolCategory === "image_generation") {
      const params = getCurrentModelParameters();
      const imageCount = params?.sampleCount || 1;
      displayMessage = imageCount > 1 ? "Generating images" : "Generating image";
    } else {
      displayMessage = TOOL_MESSAGES[toolCategory] || TOOL_MESSAGES.unknown;
    }
  }

  return {
    toolName: currentToolCallName,
    toolCategory,
    isActive,
    displayMessage,
  };
}

export default useActiveToolSkeleton;
